module.exports = __webpack_public_path__ + "img/signout-bg.c93b5dc6.jpeg";